// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React from 'react'
import PropTypes from 'prop-types'
import { Mutation } from 'react-apollo'

import {
  Input,
  Button,
  Heading,
  KeyValueTable as InputTable
} from '../../'

import { MUTATION_EMPLOYERGROUP } from '../../../mutations'


export class EmployerGroupAdd extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func,
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  state = {
    identityExistsAlready: false,
    friendlyName: '',
    legalName: '',
    notes: null
  }

  requiredInputProvided = () => (
    !!this.state.legalName &&
    !!this.state.friendlyName
  )

  save = (employergroupMutate) => {
    let input = {
      friendlyName: this.state.friendlyName,
      legalName: this.state.legalName,
      status: 'active'  // NOTE: backend status can be reviewed in the future
    }

    if (this.state.notes) {
      input.notes = this.state.notes
    }

    employergroupMutate({ variables: { input }})
    .then(this.props.onSuccess)
    .catch(error => console.error('there was an error saving the identity', error))
  }

  handleInputValueChange = (e) => {
    let field = e.target.id
    this.setState({ [field]: e.target.value })
  }

  getInputForm = () => (
    {
      '*Name (commonly used)': <Input
        id='friendlyName'
        placeholder='Enter commonly used name'
        value={this.state.friendlyName || ''}
        onChange={this.handleInputValueChange}
      />,
      '*Name (legal)': <Input
        id='legalName'
        placeholder='Enter legal name'
        value={this.state.legalName || ''}
        onChange={this.handleInputValueChange}
      />,
      'Notes': <Input
        id='notes'
        placeholder='Enter notes (if any)'
        value={this.state.notes}
        onChange={this.handleInputValueChange}
      />
    }
  )

  render() {
    return (
      <div className={this.props.className}>
        {this.props.title &&
          <Heading className='slds-text-align_center'>
            {this.props.title}
          </Heading>
        }
        <InputTable
          data={this.getInputForm()}
          keyColumnSize='1-of-2'
        />
        <div className='slds-m-top_large slds-clearfix'>
          <div className='slds-text-align_center'>
            <Button
              onClick={this.props.onCancel}
              minWidth={120}
              className='u-text-caps'>
              Cancel
            </Button>
            <Mutation mutation={MUTATION_EMPLOYERGROUP}>
              {(employergroupMutate, { data }) => (
                <Button
                  type='brand'
                  onClick={() => this.save(employergroupMutate)}
                  disabled={!this.requiredInputProvided()}
                  minWidth={120}
                  className='u-text-caps'>
                  Save
                </Button>
              )}
            </Mutation>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/messageplus/employergroup-add/index.js